import { render, staticRenderFns } from "./2020year-end.vue?vue&type=template&id=9ee5a34c&scoped=true&"
import script from "./2020year-end.vue?vue&type=script&lang=js&"
export * from "./2020year-end.vue?vue&type=script&lang=js&"
import style0 from "./2020year-end.scss?vue&type=style&index=0&id=9ee5a34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee5a34c",
  null
  
)

export default component.exports